import { render } from "./external-exam-list.vue?vue&type=template&id=a7dcb8c6&scoped=true"
import script from "./external-exam-list.vue?vue&type=script&lang=js"
export * from "./external-exam-list.vue?vue&type=script&lang=js"

import "./external-exam-list.vue?vue&type=style&index=0&id=a7dcb8c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7dcb8c6"]])

export default __exports__